module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.d7927cc9.woff";